"use client";
import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';

const EmailSignup = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const router = useRouter();

  // Check localStorage on initial load
  useEffect(() => {
    const hasSubscribed = localStorage.getItem('hasSubscribed');
    if (!hasSubscribed) {
      const timer = setTimeout(() => setShowPopup(true), 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');
  
    try {
      const response = await fetch('/api/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        // Store subscription in localStorage
        localStorage.setItem('hasSubscribed', 'true');
        setMessage(data.data.message);
        setEmail('');
        setShowPopup(false); // Close popup after successful submission
        router.push('/thank-you');
      } else {
        setMessage(data.error || 'Subscription failed');
      }
    } catch (error) {
      setMessage('Network error. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0000000f] absolute z-1">
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-20">
          <div className="bg-gray-200 rounded-2xl p-8 max-w-md relative">
            <button
              onClick={() => setShowPopup(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            <div className="text-center">
              <div className="text-green-600 mb-4">
                <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Stay Updated on Palestinian Products
              </h2>
              <p className="text-gray-700 ">
                Be first to know when new ethical products arrive from:
              </p>
              <ul className="mt-2 text-left list-disc pl-5 text-gray-700 mb-6">
                  <li>Olive wood artisans</li>
                  <li>Embroidery collectives</li>
                  <li>Fair trade organizations</li>
                </ul>
              <form onSubmit={handleSubmit} className="space-y-4 ">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  className="w-full px-4 py-3 border border-gray-400 bg-[#16120E] rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                  required
                />
                <button
                  type="submit"
                  disabled={isLoading}
                  className="w-full py-3 bg-green-700 text-white rounded-lg font-medium hover:bg-green-800 transition-colors"
                >
                  {isLoading ? 'Submitting...' : 'Join the Movement'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmailSignup;